export enum CompanyChangeStatus {
    Approve = 'Approve',
    Reject = 'Reject'
}